<mat-nav-list>
    <a mat-list-item (click)="startConversation($event)">
      <span mat-line>Start Conversation</span>
    </a>
  
    <a mat-list-item (click)="openProfile($event)">
      <span mat-line>Profile</span>
    </a>
</mat-nav-list>